import React, { useEffect, useState } from "react";
import "./ComingSoon.css";
import krushika from "./components/gz.png";
import logo from "./components/Primary-Logo.png";

export default function ComingSoon() {
  const LAUNCH_DATE = new Date("2025-12-31T00:00:00");

  const [timeLeft, setTimeLeft] = useState({
    days: "--",
    hours: "--",
    minutes: "--",
    seconds: "--",
  });

  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [sent, setSent] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [showContactSection, setShowContactSection] = useState(false);

  // Countdown timer
  useEffect(() => {
    const interval = setInterval(() => {
      const now = new Date();
      const diff = LAUNCH_DATE - now;
      if (diff <= 0) {
        clearInterval(interval);
        setTimeLeft({ days: "00", hours: "00", minutes: "00", seconds: "00" });
        return;
      }
      const days = Math.floor(diff / (1000 * 60 * 60 * 24));
      const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
      const minutes = Math.floor((diff / (1000 * 60)) % 60);
      const seconds = Math.floor((diff / 1000) % 60);
      setTimeLeft({
        days: String(days).padStart(2, "0"),
        hours: String(hours).padStart(2, "0"),
        minutes: String(minutes).padStart(2, "0"),
        seconds: String(seconds).padStart(2, "0"),
      });
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  // Show contact section on scroll
  useEffect(() => {
    const onScroll = () => {
      if (window.scrollY > 30) setShowContactSection(true);
    };
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  // Open modal after scroll shows contact
  useEffect(() => {
    if (showContactSection) {
      const timer = setTimeout(() => setModalOpen(true), 3000);
      return () => clearTimeout(timer);
    }
  }, [showContactSection]);

  const handleSend = async (e) => {
    e.preventDefault();
    try {
      await fetch("https://weekendvillas.co/ajax.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(form),
      });
      setSent(true);
      setForm({ name: "", email: "", message: "" });
      setTimeout(() => {
        setSent(false);
        setModalOpen(false);
      }, 1500);
    } catch (err) {
      console.error("Error sending form:", err);
    }
  };

  return (
    <div className="cs-root">
      <div className="cs-overlay"></div>

      <main className="cs-main">
       

        <div className="cs-contentWrapper">
          {/* Coming Soon Section */}
          <section
            className="cs-center"
            onMouseEnter={() => setShowContactSection(true)}
            style={{
              opacity: showContactSection ? 0 : 1,
              transform: showContactSection ? "translateX(-80px)" : "translateX(0)",
              pointerEvents: showContactSection ? "none" : "auto",
              transition: "all 1s ease",
            }}
          >
            <div className="rv-logo-div">
              <img className="rv-logo" src={logo} alt="logo" />
            </div>
            <h4 className="cs-pretitle">We’re Getting Ready</h4>
            <h1 className="cs-title">Coming Soon</h1>

            <div className="cs-countdown">
              <div className="countItem">
                <div className="countValue">{timeLeft.days}</div>
                <div className="countLabel">Days</div>
              </div>
              <div className="countItem">
                <div className="countValue">{timeLeft.hours}</div>
                <div className="countLabel">Hours</div>
              </div>
              <div className="countItem">
                <div className="countValue">{timeLeft.minutes}</div>
                <div className="countLabel">Minutes</div>
              </div>
              <div className="countItem">
                <div className="countValue">{timeLeft.seconds}</div>
                <div className="countLabel">Seconds</div>
              </div>
            </div>

            <p className="cs-sub">Stay tuned for something amazing!</p>
          </section>

          {/* Contact Section */}
          <section
            id="contact"
            className="contact-section"
            style={{
              opacity: showContactSection ? 1 : 0,
              transform: showContactSection ? "translateX(0)" : "translateX(80px)",
              pointerEvents: showContactSection ? "auto" : "none",
              transition: "all 1s ease",
            }}
          >
            <div className="contact-overlay"></div>

            <div className="contact-wrapper">
              {/* Left Content */}
              <div className="contact-info-block">
                <h1 className="cs-title contact-title">Get in Touch</h1>
                <p className="cs-sub contact-sub">We’d love to hear from you — let’s connect.</p>

                <div className="info-list">
                  <div className="info-item">
                    <span className="icon">📍</span>
                    <div className="info-text">
                      <label>Address</label>
                      <p>Bengaluru, Maligondanahalli, Karnataka 560074</p>
                    </div>
                  </div>

                  <div className="divider small-divider"></div>

                  <div className="info-item">
                    <span className="icon">☎️</span>
                    <div className="info-text">
                      <label>Hotline</label>
                      <p>
                        <a href="tel:+919876543210" className="contact-link">
                          +91 98765 43210
                        </a>
                      </p>
                    </div>
                  </div>

                  <div className="divider small-divider"></div>

                  <div className="info-item">
                    <span className="icon">🌐</span>
                    <div className="info-text">
                      <label>Website</label>
                      <p>
                        <a href="https://www.krushika.org" className="contact-link">
                          www.krushika.in
                        </a>
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Right Map */}
              <div className="contact-map-block">
                <div className="map-container smaller-map">
                  <iframe
                    src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d3889.0469129085436!2d77.434356!3d12.904704999999998!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMTLCsDU0JzE2LjkiTiA3N8KwMjYnMDMuNyJF!5e0!3m2!1sen!2sin!4v1762240980015!5m2!1sen!2sin"
                    title="Royal ville"
                    allowFullScreen
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                    style={{ border: 0, width: "100%", height: "100%" }}
                  ></iframe>
                </div>
              </div>
            </div>
             <button className="enquire-button" onClick={()=>setModalOpen(true)}>
              Enquire Now
            </button>
          </section>
        </div>
       
      </main>

      
      {/* Contact Badge */}
      <button className="cs-contactBadge" onClick={() => setModalOpen(true)}>
        <span className="badgeIcon">
          <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
            <path
              d="M4 4H20C21.1 4 22 4.9 22 6V18C22 19.1 21.1 20 20 20H4C2.9 20 2 19.1 2 18V6C2 4.9 2.9 4 4 4Z"
              stroke="white"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M2 6L12 11L22 6"
              stroke="white"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </span>
      </button>

      <div className="logos">
          <img src={krushika} alt="Krushika" className="cs-logo" />
      </div>

      {/* Contact Form Modal */}
      {modalOpen && (
        <div className="cs-modalBackdrop" onClick={() => setModalOpen(false)}>
          <div className="cs-modal" onClick={(e) => e.stopPropagation()}>
            <button className="modalClose" onClick={() => setModalOpen(false)}>
              ✕
            </button>
            <h3>Get in Touch</h3>
            {sent ? (
              <div className="thanks">Thanks! Message Sent 💛</div>
            ) : (
              <form className="cs-form" onSubmit={handleSend}>
                <input
                  type="text"
                  placeholder="Your Name"
                  value={form.name}
                  onChange={(e) => setForm({ ...form, name: e.target.value })}
                  required
                />
                <input
                  type="email"
                  placeholder="Your Email"
                  value={form.email}
                  onChange={(e) => setForm({ ...form, email: e.target.value })}
                  required
                />
                <textarea
                  rows="4"
                  placeholder="Message"
                  value={form.message}
                  onChange={(e) => setForm({ ...form, message: e.target.value })}
                  required
                ></textarea>
                <button className="sendBtn" type="submit">
                  Send Message
                </button>
              </form>
            )}
          </div>
        </div>
      )}

      <footer className="cs-footer">© 2025 Royal ville. All rights reserved.</footer>
    </div>
  );
}
